import ApplicationLayout from '../../../components/layouts/ApplicationLayout';
import { getWinLossOverall, getWinLossByProvider } from '../../../api/cms/summary';
import { LoadingBox } from '../../../components/LoadingBox';
import useSWR from 'swr';
import { Paper, Typography, Button, Box, makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../../components/Breadcrumbs';
import React from 'react';
import { useHistory, Link, useLocation } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableFooter,
  TablePagination,
  Fragment,
} from '@material-ui/core';
import Thead from '../../../components/table/Thead';
import TablePaginationActions from '../../../components/table/TablePaginationActions';
import RoyaltyFeeGroup from '../../../components/summary/RoyaltyFeeGroup';
import {
  providerTableHead as tableHead,
  headGroupTable,
  overAllTableHead,
  overAllHeadGroupTable,
} from '../../../components/summary/thead-data';
import { genParamsQueryFromDateRange, useDateRange } from '../../../utils/datetime';
import queryString from 'query-string';
import SummaryDateRangeContent from '../../../components/summary/SummaryDateRangeContent';
import CustomerGroup from 'components/summary/CustomerGroup';
import BOGroup from 'components/summary/BOGroup';
import DiffProviderGroup from 'components/summary/DiffProviderGroup';

const useStyles = makeStyles({
  container: {
    maxHeight: 500,
  },
  underline: {
    borderBottomColor: '#000000',
  },
});

const ByProvider = () => {
  const classes = useStyles();
  const history = useHistory();
  const { search } = useLocation();
  const paramsString = queryString.parse(search);

  const [dateRange, setDateRange] = useDateRange(paramsString);

  const searchParam = React.useMemo(() => {
    return genParamsQueryFromDateRange(dateRange);
  }, [dateRange]);

  const onChangeDateRange = (range) => {
    console.log('onChangeDateRange: ', range);
    setDateRange(range);
  };

  // const { data, error } = useSWR(
  //   ['overAllProvider', dateRange],
  //   () =>
  //     getWinLostOverall({ from_time: dateRange.startDateValue, to_time: dateRange.endDateValue }),
  //   { refreshInterval: 0, revalidateOnFocus: false, shouldRetryOnError: false },
  // );
  const { data, error } = useSWR(
    ['overAllProvider', dateRange],
    () =>
      getWinLossOverall({ from_time: dateRange.startDateValue, to_time: dateRange.endDateValue }),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  // const { data: dataProvider, error: errorProvider } = useSWR(
  //   ['getProvider', page, rowsPerPage, dateRange],
  //   (url, page, limit) =>
  //     getWinLostByProvider({
  //       page: page + 1,
  //       limit,
  //       from_time: dateRange.startDateValue,
  //       to_time: dateRange.endDateValue,
  //     }),
  //   { refreshInterval: 0, revalidateOnFocus: false, shouldRetryOnError: false },
  // );
  const { data: dataProvider, error: errorProvider } = useSWR(
    ['getProvider', page, rowsPerPage, dateRange],
    (url, page, limit) =>
      getWinLossByProvider({
        page: page + 1,
        limit,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
    { refreshInterval: 0, revalidateOnFocus: false, shouldRetryOnError: false },
  );
  const { logs = [], total = 0 } = dataProvider || {};

  if (error || errorProvider) toast.error('error');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <ApplicationLayout>
      <Breadcrumbs />
      <SummaryDateRangeContent
        onChange={onChangeDateRange}
        defaultValue={dateRange}
        value={dateRange}
      />
      {!data ? (
        <LoadingBox />
      ) : (
        <>
          <Box my={2}>
            <Typography variant="h6" gutterBottom component="div">
              System's Overall
            </Typography>
            <TableContainer component={Paper}>
              <Table aria-label="win lost table" size="small">
                <Thead heads={overAllHeadGroupTable} align="center" />
                <Thead heads={overAllTableHead} align="center" />
                <TableBody>
                  {data.map((row, index) => (
                    <TableRow key={index}>
                      <RoyaltyFeeGroup data={row} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
      {!logs ? (
        <LoadingBox />
      ) : (
        <>
          <Typography variant="h6" gutterBottom component="div">
            Provider's Win/Lose
          </Typography>
          <TableContainer component={Paper} className={classes.container}>
            <Table aria-label="win lost sticky table">
              <Thead heads={headGroupTable} align="center" />
              <Thead heads={tableHead} align="center" />
              <TableBody>
                {logs.map((row, index) => (
                  <>
                    <TableRow key={index}>
                      <TableCell align="center" rowSpan={2}>
                        <Link to={`provider/${row.provider_code}?${searchParam}`}>
                          {row.provider_name}
                        </Link>
                      </TableCell>
                      <TableCell align="center">9X</TableCell>
                      <RoyaltyFeeGroup data={row} disabledBg={true} rowSpan={2} />
                    </TableRow>
                    <TableRow>
                      <TableCell align="center">Provider</TableCell>
                      <BOGroup data={row} disabledBg={true} />
                    </TableRow>
                    <TableRow>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">Total</TableCell>
                      <DiffProviderGroup data={row} disabledBg={true} />
                      <TableCell align="center" colSpan={3}>
                        -
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell align="center">รวม</TableCell>
                  <TableCell align="center">#</TableCell>
                  <RoyaltyFeeGroup data={data?.[0] || []} disabledBg />
                </TableRow>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[100, 250, 500, { label: 'All', value: 0 }]}
                    colSpan={9}
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </>
      )}
    </ApplicationLayout>
  );
};

export default ByProvider;
